module.exports = __webpack_public_path__ + "img/org_3.496ec770.jpeg";